<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="false"
    :showCancelBtn="false"
    class="saba-parlay-result"
    width="70%"
    append-to-body
    :visible.sync="visible"
    :showIcon="false"
    @opened="handleOpen"
  >
    <template slot="title">
      <div style="font-color: white">
        <span
          style="color: white; float: left; margin-left: 10px"
          class="title-text"
          >{{ $t("column.createtime") }}:{{ searchData.createtime }}</span
        >
        <span style="color: white" class="title-text">{{$t("column.parlay_result")}}</span>
        <span
          style="color: white; float: right; margin-right: 40px"
          class="title-text"
          >{{ $t("column.bet_id") }}:{{ searchData.betId }}</span
        >
      </div>
    </template>

    <tg-layout ref="layout" :headerHeight="showAmountBar ? 100 : 0">
      <template slot="header">
        <tg-amount-bar
          ref="amount"
          :columns="amountColumns"
          :row="amountData"
          v-show="showAmountBar"
        ></tg-amount-bar>
      </template>
      <tg-table
        ref="table"
        :columns="columns"
        :proxy="proxy"
        align="center"
        :fit="true"
        :span-method="objectSpanMethod"
        @on-loaded="handleLoaded"
        @on-scroll="handleTableScroll"
      >
        <!-- 賽事 -->
        <template slot="match" slot-scope="scope">
          <template v-if="searchData.content_type == 3">
            <template v-for="(item, index) in scope.row['matches']">
              <el-row :key="index" :gutter="2" type="flex" align="center">
                <span
                  ><i class="tg-icon tg-icon-grayball"></i
                  >{{ item["team1"] }}</span
                >
                <span class="mb-3"> vs </span>
                <span
                  >{{ item["team2"] }}</span
                ><br :key="index" />
              </el-row>
            </template>
          </template>

          <template v-else-if="searchData.content_type == 4">
            <span class="text-saba">{{ scope.row.sport_name }}</span
            ><br />
            <template v-if="Array.isArray(scope.row.competition)">
              <template v-for="(item, index) in scope.row.competition">
                <span v-if="index == 0" style="color: black" :key="index"
                  >[{{ item }}]</span
                >
                <span v-else style="color: gray" :key="index">({{ item }})</span
                ><br :key="index" />
              </template>
            </template>
            <template
              v-else-if="
                scope.row.competition != '' && scope.row.competition != null
              "
            >
              <span style="color: black">[{{ scope.row.competition }}]</span
              ><br />
            </template>
            <template v-if="scope.row.team1 != '' || scope.row.team2 != ''">
              <span
                ><i class="tg-icon tg-icon-grayball"></i
                >{{ scope.row.team1 }}</span
              ><br />
              <span
                ><i class="tg-icon tg-icon-grayball"></i
                >{{ scope.row.team2 }}</span
              ><br />
            </template>
          </template>

          <template v-else>
            <template v-for="(item, index) in scope.row['matches']">
              <el-row :key="index"  type="flex" align="center">
                <span
                  ><i class="tg-icon tg-icon-grayball"></i
                  >{{ item }}</span
                >
              </el-row>
            </template>
          </template>
        </template>

        <!-- 賠率 -->
        <template slot="odds" slot-scope="scope">
          <template>
            <el-row type="flex" justify="center" align="middle">
              <i class="tg-icon tg-icon-game"></i>
              <span v-if="searchData.content_type == 3">{{ scope.row.odds | floatFilter_4 }}</span>
              <span v-else>{{ scope.row.odds }}%</span>
            </el-row>
          </template>

          <template v-if="searchData.content_type == 4">
            <el-row type="flex" justify="start" align="left">
              <i class="tg-icon tg-icon-game"></i>
              <span>{{ scope.row.profit | floatFilter_4 }}</span>
            </el-row>
          </template>
        </template>

      <template slot="cell" slot-scope="scope">
        <span
          :class="{
            'text-red': scope.value < 0,
            'text-green': scope.value > 0,
          }"
          >{{ scope.formated }}</span
        >
      </template>

        <!-- 注單內容 -->
        <template slot="bet_content" slot-scope="scope">
          <el-row type="flex" justify="start" align="left">
            <i class="tg-icon tg-icon-game"></i>
            <span class="text-green" :key="index">
              {{scope.row.bets.bet_content}}
            </span>
          </el-row>
        </template>

        <!-- 狀態 result  0: 未結算 1: 勝 2: 負 3: 和 其餘用 - 表示  -->
        <template slot="status" slot-scope="scope">
          <template v-if="searchData.content_type == 3">
            <span v-if="scope.row.result < 4">
              {{ $t("enum.game.status[" + scope.row.result + "]") }}
            </span>
            <span v-else> - </span>
          </template>

          <template v-else-if="searchData.content_type == 4">
            <span v-if="scope.row.bets.result < 4" :key="index">
              {{ $t("enum.game.status[" + scope.row.bets.result + "]") }}
            </span>
            <span v-else :key="index"> - </span>
          </template>

          <template v-else-if="searchData.content_type == 17">
            <span :key="index">
              {{ $t("enum.game.ob_sport.status[" + scope.row.betResult+ "]") }}
            </span>
          </template>

          <template v-else>
            <span :key="index">
              {{ $t("enum.game.status[" + scope.row.betResult+ "]") }}
            </span>
          </template>
        </template>
      </tg-table>
    </tg-layout>
  </tg-dialog>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgAmountBar from "@/components/amount/TgAmountBar";

import apis from "@/apis";
import TgDialog from "@/components/dialog/TgDialog.vue";
var api = apis.third_party.public_sport.result;

export default {
  inheritAttrs: false,
  components: {
    TgLayout,
    TgTable,
    TgAmountBar,
    TgDialog,
  },
  provide() {
    return {
      container: this.$el,
    };
  },
  data() {
    return {
      columns: [],
      amountColumns: [],
      amountData: {},
      multipleCol: [],
      singleCol: [],
      proxy: api.getData,
      showAmountBar: false,
      length: 0,
      bets_length: 0,
      searchData: {},
      visible: false,
    };
  },
  created() {
    
  },
  methods: {
    handleOpen() {
      if (this.$refs.table) {
        this.$refs.table.init(this.searchData);
      }
    },
    showDialogForPublic(request) {
      api = apis.third_party.public_sport.result;
      this.proxy = api.getData;
      api.getColumns().then((response) => {
        this.amountColumns = response.data.multiple;
        this.amountColumns = this.amountColumns.slice(2, 5);

        this.multipleCol = response.data.multiple;
        this.singleCol = response.data.single;
        this.multipleCol.splice(2, 1);
        this.visible = true;
        this.searchData = request;
      });
    },
    handleLoaded(response) {
      if (this.searchData.content_type == 4) {
        this.showAmountBar = false;
        this.columns = this.singleCol;
        this.bets_length = response.bets.length;
      }else {
        this.columns = this.multipleCol;
        this.showAmountBar = true;
        this.amountData = response.amountData;
      }
    },
    handleTableScroll(e) {
      let target = e.target;
      this.$refs.amount.syncScrollX(
        target.scrollWidth - target.offsetWidth,
        target.scrollLeft
      );
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (
        row.marketType == 38 &&
        (columnIndex === 0 || columnIndex === 1 || columnIndex === 4)
      ) {
        if (rowIndex === 0) {
          return {
            rowspan: this.bets_length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
  filters:{
    floatFilter_4(value){
      let newVal = '';
      if(!isNaN(value) && value != ''){
        newVal = parseFloat(value).toFixed(4);
      }
      return newVal;
    }
  }
};
</script>
